var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar',[_c('div',{staticClass:"navbar-wrapper"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.pageTitle)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }